import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {CoinShowModelSendSignal} from "../../../_models/send-signal-show";
import {DialogComponent, DialogService} from "ng2-bootstrap-modal";

@Component({
    selector: 'app-popup-show-list-coin',
    templateUrl: './popup-show-list-coin.component.html',
    styleUrls: ['./../send-signal-event.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class PopupShowListCoinComponent extends DialogComponent<CoinShowModelSendSignal, boolean> implements OnInit {

    titlePopup: string;
    listCoinEvent: any = [];
    listCoinSendSignal: any = {};
    listCoinNameActive: any [];

    constructor(dialogService: DialogService) {
        super(dialogService);
    }

    ngOnInit() {
        this.listCoinNameActive = this.listCoinSendSignal.listCoinNameActive;
    }

    closeDialogBox() {
        this.close();
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/send-signal-event/popup-show-list-coin/popup-show-list-coin.component.ts